import { OnInit,ViewChild, OnDestroy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {  statusCode } from '../../../auth/models/commonEnum';
import { CoreConfigService } from '@core/services/config.service';
import { MyApplicationService } from '../../../../../src/app/main/my-application/my-application.service';
import { Router,NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  @ViewChild('content', { static: true }) content: any;
  public coreConfig: any;
  public totalVisitor: any;
  public totalHit: any;
  public year: number = new Date().getFullYear();
  public currentDate: any;
  public dayDifference: any;
  public updatedAt: any;
  currentUrl: string;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(public _coreConfigService: CoreConfigService, public _MyApplicationService: MyApplicationService, private router: Router, private modalService: NgbModal,private datePipe: DatePipe) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');
   
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  navigateToUrl(): void {
    window.location.href = '/pages/account-settings';
    //this.router.navigate(['/pages/account-settings']); // Navigate to the '/about' route
  }
  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    if(localStorage.getItem('token'))
      {
       this.getUserData();
      }
    this.getVisitorList();
    this.addVisitorCount();
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  getUserData() {
    const data = {}
    
    this._MyApplicationService.getProfileData().subscribe((result: any) => {
      this.updatedAt = result["data"]['response']['updatedAt'];
      console.log(this.updatedAt);
      const date1Parsed = new Date(this.updatedAt);
      const date2Parsed = new Date(this.currentDate);
    
      // Calculate the time difference in milliseconds
      const timeDifference = Math.abs(date2Parsed.getTime() - date1Parsed.getTime());
    
      // Convert the time difference to days
      this.dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
          this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
          ).subscribe(() => {
            this.currentUrl = this.router.url;
            if(this.dayDifference>90 && this.currentUrl != "/pages/account-settings"){
              this.modalService.open(this.content, { backdrop: 'static', keyboard: false });
              }
          });   

    });

  }

  getVisitorList() {
    const data = {}
    
    this._MyApplicationService.getVisitorCount(data).subscribe((result: any) => {
      if (result.statusCode == statusCode.SUCCESS) {
        this.totalHit = result["data"]['response']["totalHit"];
        this.totalVisitor = result["data"]['response']["totalVisitor"];
      }
      else {
        this.totalHit = [];
        this.totalVisitor = [];
      }
    });
  }

  addVisitorCount() {
		
		const data = {}
		this._MyApplicationService
		.addVisitorCount(data).subscribe(
			response => {
				if (Number(response["statusCode"]) === statusCode.SUCCESS) {
          //console.warn(response["statusCode"]);
        }
			}
			);
return false;
	}

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
